import { CloseIcon } from 'assets/icons/CloseIcon'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { Modal } from 'components/Modal/Modal'
import { editScheduledBreak } from 'features/breaks/breaksSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const ScheduledBreaksModal = ({ closeModal, value }: { closeModal: any, value?: IScheduledBreaksModalState }) => {
    const [state, setState] = useState<IScheduledBreaksModalState>(value || {
        userId: null,
        breakIndex: null,
        newStartDate: null,
    })
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleSave = async () => {
        const resp = await dispatch(editScheduledBreak(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }


    return <Modal black>
        <Flex column between center >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >Edit Scheduled Break</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Flex gap='1rem' >
                    <CalendarInput width='100%' labelText='New Start Date' defaultValue={state.newStartDate} includeTime onChange={newStartDate => setState(prev => ({ ...prev, newStartDate }))} />
                </Flex>
            </Flex>
            <Button mt='16' orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

export interface IScheduledBreaksModalState {
    userId: number
    breakIndex: number
    newStartDate: string
}